// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Check = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 12 9"
        fill="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        focusable="false"
        width="24"
        height="24"
    >
        <path d="M11.25 1.5a.747.747 0 01-.22.53l-6 6a.746.746 0 01-1.06 0l-3-3a.75.75 0 011.06-1.06L4.5 6.44 9.97.97a.75.75 0 011.28.53z" />
    </svg>
);

export default React.memo(Check);
